let value = ("undefined" !== typeof self ? self : this)["webpackJsonpvuecal"] || [];
(value).push([[38], {
    a5dc: function (e) {
        e.exports = JSON.parse(`{
            "weekDays": ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日"],
            "weekDaysShort": ["一", "二", "三", "四", "五", "六", "日"],
            "months": ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
            "years": "年",
            "year": "本年",
            "month": "月",
            "week": "周",
            "day": "日",
            "today": "今日",
            "noEvent": "暫無活動",
            "allDay": "整天",
            "deleteEvent": "刪除",
            "createEvent": "新建活動",
            "dateFormat": "YYYY MMMM D dddd"
        }`)
    }
}]);